const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5215';

const makeRequest = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
  const data = await response.json();
  if (!response.ok) {
    const err = new Error(data.message || `HTTP error! status: ${response.status}`);
    err.status = response.status;
    err.details = data;
    throw err;
  }
  return data;
};

export const createResourceGroup = async (tenantName) => {
  const url = `${API_BASE_URL}/api/tenantprovisioning/create-resource-group`;
  return await makeRequest(url, {
    method: 'POST',
    body: JSON.stringify({ tenantName: tenantName.trim().toLowerCase() }),
  });
};

export const validateDeployment = async (tenantName) => {
  const url = `${API_BASE_URL}/api/tenantprovisioning/validate`;
  return await makeRequest(url, {
    method: 'POST',
    body: JSON.stringify({ tenantName: tenantName.trim().toLowerCase() }),
  });
};

export const deploy = async (tenantName) => {
  const url = `${API_BASE_URL}/api/tenantprovisioning/deploy`;
  return await makeRequest(url, {
    method: 'POST',
    body: JSON.stringify({ tenantName: tenantName.trim().toLowerCase() }),
  });
};

export const createSimulcastResourceGroup = async (tenantName) => {
  const url = `${API_BASE_URL}/api/tenantprovisioning/simulcast/create-resource-group`;
  return await makeRequest(url, {
    method: 'POST',
    body: JSON.stringify({ tenantName: tenantName.trim().toLowerCase() }),
  });
};

export const validateSimulcastDeployment = async (tenantName) => {
  const url = `${API_BASE_URL}/api/tenantprovisioning/simulcast/validate`;
  return await makeRequest(url, {
    method: 'POST',
    body: JSON.stringify({ tenantName: tenantName.trim().toLowerCase() }),
  });
};

export const deploySimulcast = async (tenantName) => {
  const url = `${API_BASE_URL}/api/tenantprovisioning/simulcast/deploy`;
  return await makeRequest(url, {
    method: 'POST',
    body: JSON.stringify({ tenantName: tenantName.trim().toLowerCase() }),
  });
};
